import React from 'react'

const Dropdown = (props) => {

    let { lableProps, items, selectHandle, value, extraCSS } = props.propsData
    const handleSelect =(a)=>{
        selectHandle(a.target.name, a.target.value)
    }
    return (
        <div className={extraCSS || "dropdown-core"}>
            <label for={lableProps.id}>{lableProps.label}</label>
            <select id={lableProps.id} name={lableProps.id} value={value} onChange={handleSelect}>
                {items.map(item => <option value={item.key}>{item.value}</option>)}
            </select>
        </div>
    )
}

export default Dropdown